import React from 'react';
import CloseRounded from '@material-ui/icons/CloseRounded';

import Component from '../../../../../ui-components/Component';
import styles from './styles';
import IconButton from '../../../../../ui-components/Button/Icon';
import { getImage } from '../../../../../resources/images';

class PropertyLinkHelp extends Component {

    styles = styles;
    helpSteps = ['open_a_web', 'go_to_travel', 'go_to_your', 'copy_the_url'];

    render = () => <>
        <div style={this.gs('header')}>
            <div style={this.gs('title')}>{this.props.gc('how_to_find')}{'?'}</div>
            <IconButton onClick={this.props.onClose}><CloseRounded /></IconButton>
        </div>
        <div style={this.gs('image_container')}>
            <img src={getImage('booking_sample_ota_url.png')} alt='url_help' style={this.gs('image')} />
        </div>
        <ol style={this.gs('content')}>
            {this.helpSteps.map((step, index) => <li key={index} style={this.gs('text')}>{this.props.gc(step)}</li>)}
        </ol>
    </>;

}

export default PropertyLinkHelp;